"use client";

import { cn } from "@/lib";
import { useTranslations } from "next-intl";
import React, { ComponentProps } from "react";

export interface TableHeader {
  key: string;
  label: string;
}

interface TableProps<T extends Record<string, any>>
  extends ComponentProps<"div"> {
  headers: TableHeader[];
  data: T[];
  className?: string;
}

const Table = <T extends Record<string, any>>({
  headers,
  data,
  className,
}: TableProps<T>) => {
  const t = useTranslations();
  return (
    <div
      className={cn(
        "no-scrollbar relative h-full grow overflow-x-auto sm:overflow-x-hidden",
        className,
      )}
    >
      <table className="w-max sm:w-full">
        <thead className="text-center uppercase">
          <tr>
            {headers.map((header) => (
              <th
                key={header.key as string}
                scope="col"
                className="px-6 py-3 text-sm font-semibold"
              >
                {t(header.label as any)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-custom-gray-200 text-center">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header, colIndex) => (
                <td key={colIndex} className="px-6 py-4 text-sm">
                  {row[header.key as keyof T]?.toString()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
